import styles from './styles.module.scss';

type Option = {
  /** 容器 DOM */
  container: HTMLElement;
  /** 自动隐藏 */
  autoHide?: number;
  /** 内容格式化 */
  formatter: (data: unknown) => string;
};

const OFFSET = [8, 8];
const DEFAULT_AUTO_HIDE = 0e3;

export default class Tooltip {
  private __option: Option;

  private __$dom!: HTMLElement;

  private __hideTimer!: ReturnType<typeof setTimeout>;

  constructor(option: Option) {
    this.__option = option;

    this.__initialize();
  }

  private __initialize() {
    this.__$dom = document.createElement('div');
    this.__$dom.classList.add(styles.container);

    this.__option.container.appendChild(this.__$dom);
  }

  private __update(coords: [number, number], content: string) {
    const containerBBox = this.__$dom.parentElement!.getBoundingClientRect();

    this.__$dom.innerHTML = content;
    this.__$dom.style.display = 'block';

    const contentBBox = this.__$dom.getBoundingClientRect();

    let [x, y] = coords;

    if (x + OFFSET[0] + contentBBox.width > containerBBox.width) {
      x = Math.max(0, x - OFFSET[0] - contentBBox.width);
    } else {
      x += OFFSET[0];
    }
    if (y + OFFSET[1] > containerBBox.height) {
      y = Math.max(0, y - OFFSET[1] - contentBBox.height);
    } else {
      y += OFFSET[1];
    }

    this.__$dom.style.left = `${x}px`;
    this.__$dom.style.top = `${y}px`;
  }

  show(coords: [number, number], data: unknown) {
    if (this.__hideTimer) {
      clearTimeout(this.__hideTimer);
    }

    const content = this.__option.formatter(data);

    this.__update(coords, content);
  }

  hide() {
    this.__$dom.style.display = 'none';
  }

  autoHide() {
    if (this.__hideTimer) {
      clearTimeout(this.__hideTimer);
    }

    this.__hideTimer = setTimeout(() => {
      this.hide();
    }, this.__option.autoHide ?? DEFAULT_AUTO_HIDE);
  }

  destroy() {
    if (this.__hideTimer !== null) {
      clearTimeout(this.__hideTimer);
    }
    this.__$dom.parentElement!.removeChild(this.__$dom);
  }
}
